module.exports = __webpack_public_path__ + "static/img/15.44d251d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/15.png
// module id = Pkmp
// module chunks = 0